import ReactDOM from 'react-dom/client'
import PortfolioApp from '@/PortfolioApp'

ReactDOM.createRoot(document.getElementById('root')).render(<PortfolioApp />)
